var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h1", [_vm._v("Gestion des droits d'accès")]),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { slot: "tool", gutter: 10 }, slot: "tool" },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    icon: "el-icon-circle-plus-outline",
                    type: "primary",
                    size: "mini"
                  },
                  on: {
                    click: function($event) {
                      return _vm.$router.push("/admin/permission/new")
                    }
                  }
                },
                [_vm._v("Nouveau")]
              ),
              _vm._v(" "),
              _vm.multipleSelection.length > 0
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        type: "danger",
                        size: "mini",
                        icon: "el-icon-delete"
                      },
                      on: { click: _vm.handleDeleteSelection }
                    },
                    [_vm._v("Supprimer la sélection")]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("p", [
        _vm._v("  Société : " + _vm._s(_vm.$store.getters.user.societe_name))
      ]),
      _vm._v(" "),
      _c(
        "data-tables",
        {
          ref: "dataTable",
          attrs: {
            data: _vm.permission,
            total: _vm.total,
            layout: "tool, table"
          },
          on: { "selection-change": _vm.handleSelectionChange }
        },
        [
          _c("el-table-column", { attrs: { type: "selection", width: "45" } }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { width: "70" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("el-button", {
                      attrs: { type: "text", icon: "el-icon-delete" },
                      on: {
                        click: function($event) {
                          return _vm.handleDelete(scope.$index, scope.row)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("el-button", {
                      attrs: { type: "text", icon: "el-icon-edit" },
                      on: {
                        click: function($event) {
                          return _vm.$router.push(
                            "/admin/permission/edit/" + scope.row.id
                          )
                        }
                      }
                    })
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _vm._l(_vm.columns, function(col, index) {
            return _c("el-table-column", {
              key: col.id,
              attrs: {
                prop: col.prop,
                label: col.label,
                sortable: "custom",
                width: _vm.ColWidth(index)
              }
            })
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }